import styled from 'styled-components';

interface FeatureStyledProps {
  selected?: boolean;
  highlighted?: boolean;
  onMouseEnter?: Function;
}

export const FeatureStyled = styled.div<FeatureStyledProps>(
  ({ theme, selected, highlighted, onMouseEnter }) => ({
    paddingTop: theme.borderRadius.xsmall,
    paddingBottom: theme.borderRadius.xsmall,
    cursor: onMouseEnter && 'pointer',
    paddingLeft: '0.5rem',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    fontSize: theme.font.size.small,
    lineHeight: theme.font.lineHeight.medium,
    color: theme.color.wfGrey900,
    // eslint-disable-next-line no-nested-ternary
    background: highlighted
      ? selected
        ? theme.color.wfPurple100
        : theme.color.wfYellow200
      : selected && theme.color.wfOrange100,
  }),
);
